import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import {
  ShoppingListState,
  ShoppingListItem,
  GoodsItem,
} from "../../types/types";

// Функции для работы с localStorage
const STORAGE_KEY = "skynet_shopping_list";

const loadFromLocalStorage = (): ShoppingListItem[] => {
  try {
    const saved = localStorage.getItem(STORAGE_KEY);
    return saved ? JSON.parse(saved) : [];
  } catch (error) {
    console.error("Error loading shopping list from localStorage:", error);
    return [];
  }
};

const saveToLocalStorage = (items: ShoppingListItem[]) => {
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(items));
  } catch (error) {
    console.error("Error saving shopping list to localStorage:", error);
  }
};

const initialState: ShoppingListState = {
  items: loadFromLocalStorage(),
  isOpen: false,
};

const shoppingListSlice = createSlice({
  name: "shoppingList",
  initialState,
  reducers: {
    toggleShoppingList: (state) => {
      state.isOpen = !state.isOpen;
    },

    openShoppingList: (state) => {
      state.isOpen = true;
    },

    closeShoppingList: (state) => {
      state.isOpen = false;
    },

    addToShoppingList: (state, action: PayloadAction<GoodsItem>) => {
      const item = action.payload;
      const existingItem = state.items.find(
        (listItem) => listItem.id === item.id
      );

      if (!existingItem) {
        const newItem: ShoppingListItem = {
          id: item.id,
          kod: item.kod,
          title: item.title,
          sub_title: item.sub_title,
          image: item.image,
          price_3: item.price_3,
          price_4: item.price_4,
          currency: item.currency,
          quantity: 1,
          addedAt: new Date().toISOString(),
        };
        state.items.push(newItem);
        saveToLocalStorage(state.items);
      }
    },

    removeFromShoppingList: (state, action: PayloadAction<number>) => {
      state.items = state.items.filter((item) => item.id !== action.payload);
      saveToLocalStorage(state.items);
    },

    updateQuantity: (
      state,
      action: PayloadAction<{ id: number; quantity: number }>
    ) => {
      const { id, quantity } = action.payload;
      const item = state.items.find((item) => item.id === id);
      if (item && quantity > 0) {
        item.quantity = quantity;
        saveToLocalStorage(state.items);
      }
    },

    clearShoppingList: (state) => {
      state.items = [];
      saveToLocalStorage(state.items);
    },

    // Загрузка из localStorage при инициализации приложения
    loadShoppingListFromStorage: (state) => {
      state.items = loadFromLocalStorage();
    },
  },
});

export const {
  toggleShoppingList,
  openShoppingList,
  closeShoppingList,
  addToShoppingList,
  removeFromShoppingList,
  updateQuantity,
  clearShoppingList,
  loadShoppingListFromStorage,
} = shoppingListSlice.actions;

export default shoppingListSlice.reducer;
